import React, { ReactNode } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import green from '@material-ui/core/colors/green';

export interface PromisKeyProps {
  classes?: Partial<ReturnType<typeof useStyles>>;
}

export default function PromisKey(props: PromisKeyProps) {
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <Typography className={classes.header}>
        PROMIS® Scores:
      </Typography>
      <div className={classes.icon} style={{ color: green[500] }}>●</div>
      <Typography className={classes.label}>Normal</Typography>
      <div className={classes.icon} style={{ color: yellow[500] }}>●</div>
      <Typography className={classes.label}>Mild</Typography>
      <div className={classes.icon} style={{ color: orange[500] }}>●</div>
      <Typography className={classes.label}>Moderate</Typography>
      <div className={classes.icon} style={{ color: red[500] }}>●</div>
      <Typography className={classes.label}>Severe</Typography>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
  },
  header: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  icon: {
    marginLeft: theme.spacing(2),
    fontSize: 24,
  },
  label: {
    marginLeft: theme.spacing(0.5),
    fontSize: 14,
  },
}));
